import { FormatShapeDto, ProductTableProductDetails } from '../types';
import { ProductTableProductDetailsRow } from './useTapeCaseProductDetails';

export const CIRCLE_WITH_HOLE_SHAPE = 'Circle with Hole';
export const CIRCLE_SHAPE = 'Circle';
export const DIAMETER_NAME = 'Diameter';
export const WIDTH_NAME = 'Width';
export const LENGTH_NAME = 'Length';

export function mapProductDetails(details: ProductTableProductDetails): ProductTableProductDetailsRow {
	switch (details.formatShape) {
		case CIRCLE_SHAPE:
			return {
				details: details,
				colorFilterValue: details.color ?? '',
				dimension1FilterValue: details.diameter ?? '',
				dimension2FilterValue: '',
			};

		case CIRCLE_WITH_HOLE_SHAPE:
			return {
				details: details,
				colorFilterValue: details.color ?? '',
				dimension1FilterValue: details.diameter ?? '',
				dimension2FilterValue: details.innerHoleDiameter ?? '',
			};

		default:
			return {
				details: details,
				colorFilterValue: details.color ?? '',
				dimension1FilterValue: details.width ?? '',
				dimension2FilterValue: details.length ?? '',
			};
	}
}

/**
 * Resolves column names for dimensions depending on the format/shape type
 * dimension 1 is always available (Width or Diameter)
 * but dimension 2 is optional (Length or Inner Hole Diameter, but no value for Circles)
 */
export function resolveColumnNames(formatShape: FormatShapeDto | null): [string, string | null] {
	let dimension1ColumnName = WIDTH_NAME;
	let dimension2ColumnName: string | null = LENGTH_NAME;
	if (formatShape != null) {
		switch (formatShape.name) {
			case CIRCLE_SHAPE:
				dimension1ColumnName = DIAMETER_NAME;
				dimension2ColumnName = null;
				break;
			case CIRCLE_WITH_HOLE_SHAPE:
				dimension1ColumnName = DIAMETER_NAME;
				dimension2ColumnName = 'Inner Hole Diameter';
				break;
		}
	}

	return [dimension1ColumnName, dimension2ColumnName];
}
